document.addEventListener('DOMContentLoaded', function() {
  const STORAGE_KEY = 'anand_wishlist';
  let wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

  function updateHeaderCount() {
    const countSpan = document.querySelector('#wishlist-icon .wishlist-count, .wishlist-count');
    const bubble = document.querySelector('#wishlist-icon .wishlist-count-bubble, .wishlist-count-bubble');
    
    if (countSpan) {
      countSpan.innerText = wishlist.length;
    }
    if (bubble) {
      if (wishlist.length > 0) {
        bubble.style.display = 'flex';
      } else {
        bubble.style.display = 'none';
      }
    }
  }

  function syncActiveStates() {
    const buttons = document.querySelectorAll('.card__wishlist-btn, .new-card-wishlist-btn, .showcase-wishlist-btn');
    buttons.forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (handle && wishlist.includes(handle)) {
        btn.classList.add('active', 'is-wishlisted');
        const icon = btn.querySelector('.card__wishlist-icon, .new-card-wishlist-icon, .showcase-wishlist-icon');
        if (icon) icon.setAttribute('fill', 'currentColor');
      } else {
        btn.classList.remove('active', 'is-wishlisted');
        const icon = btn.querySelector('.card__wishlist-icon, .new-card-wishlist-icon, .showcase-wishlist-icon');
        if (icon) icon.setAttribute('fill', 'none');
      }
    });
  }

  // Event delegation click handler on document to capture all wishlist heart clicks instantly!
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.card__wishlist-btn, .new-card-wishlist-btn, .showcase-wishlist-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productHandle = btn.getAttribute('data-product-handle');
    if (!productHandle) return;

    if (wishlist.includes(productHandle)) {
      // Remove
      wishlist = wishlist.filter(h => h !== productHandle);
    } else {
      // Add
      wishlist.push(productHandle);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
    
    // Instantly sync visual state across all buttons on the page with this same handle
    document.querySelectorAll(`[data-product-handle="${productHandle}"]`).forEach(el => {
      const icon = el.querySelector('.card__wishlist-icon, .new-card-wishlist-icon, .showcase-wishlist-icon');
      if (wishlist.includes(productHandle)) {
        el.classList.add('active', 'is-wishlisted');
        if (icon) icon.setAttribute('fill', 'currentColor');
      } else {
        el.classList.remove('active', 'is-wishlisted');
        if (icon) icon.setAttribute('fill', 'none');
      }
    });

    updateHeaderCount();
  });

  // Initial Sync
  syncActiveStates();
  updateHeaderCount();

  // Keep observing mutations just to apply active class to new cards, but let event delegation handle clicks!
  const observer = new MutationObserver((mutations) => {
    syncActiveStates();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
